import React, { useEffect, useState } from "react";
import { changeLanguage, getLanguage } from "@config/i18n";
import { KDropdown, KDropItem } from "@components/KDropdown";
import { LanguageResource } from "@modules/profile/features/configuration/resources/Language.resource";
import { useLanguages } from "@infrastructure/context/languages/useLanguage";

export const LanguageSelector = () => {
  const languages = useLanguages();
  const currentLanguage = getLanguage();
  const [items, setItems] = useState<Array<KDropItem>>([]);

  useEffect(() => {
    const items = languages.items.map((language) => ({
      label: language.name!,
      value: language.shortCode,
    }));

    setItems(items);
  }, [languages]);

  const setLanguage = (languageCode: string) => {
    if (currentLanguage === languageCode) {
      return;
    }
    const lng = languages.items.find(
      (language) => language.shortCode === languageCode
    );

    if (lng && lng.id) {
      LanguageResource.updateLanguage(lng.id).then(() => {
        changeLanguage(languageCode);
      });
    }
  };

  return (
    <KDropdown items={items} value={currentLanguage} onSelect={setLanguage} />
  );
};
